module.exports = __webpack_public_path__ + "img/lepricon_white.509cdec7.png";